import React from "react";
import {OverlayTrigger, Table, Tooltip} from "react-bootstrap";
import HeaderWithHelp from "../SalesAnalysis/HeaderWithHelp.jsx";
import {formatDatum, formatMenge} from "./format.js";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

const STATUS = {
    nicht_zugeordnet: {klasse: "text-bg-secondary", label: "nicht zugeordnet", hilfe: "Für diesen Cosmos-Code ist keine Weclapp-Artikelnummer bekannt. Die Menge steckt trotzdem in der Summe."},
    dublette: {klasse: "text-bg-warning", label: "Dublette", hilfe: "Dieser Code steht mehrfach in der Cosmos-Liste. Die Mengen wurden weder addiert noch verworfen - jede Zeile steht einzeln da."},
    klaerung: {klasse: "text-bg-danger", label: "Klärungsfall", hilfe: "Die Zuordnung darf nicht geraten werden und ist mit Cosmos zu klären."},
};

/**
 * Zeilen der jüngsten Cosmos-Bestandsliste, die keine sichere
 * Weclapp-Zuordnung haben (Auftrag #236): nicht zugeordnet, Dubletten,
 * Klärungsfälle. Der Baustein verschwindet vollständig, wenn es nichts zu
 * melden gibt oder noch keine Liste importiert wurde.
 */
export default function BestandslisteZuordnung({bestandsliste}) {
    if (!bestandsliste || !bestandsliste.meldungen || bestandsliste.meldungen.length === 0) {
        return null;
    }

    return (
        <>
            <h2 className="h5 mt-4">
                <HeaderWithHelp help="Zeilen der jüngsten Cosmos-Bestandsliste, bei denen der Cosmos-Code keiner Weclapp-Artikelnummer sicher zugeordnet werden konnte. Nichts davon wird verworfen oder addiert - es steht hier, damit es geklärt werden kann.">
                    Cosmos-Liste: Zeilen ohne sichere Zuordnung
                </HeaderWithHelp>
            </h2>
            <p className="small text-muted">
                Stand der Liste: {formatDatum(bestandsliste.stand_am)}
                {bestandsliste.dateiname ? ` (${bestandsliste.dateiname})` : ""}. Die Mengen sind brutto und enthalten offene Bestellungen.
            </p>
            <Table responsive size="sm" className="align-middle">
                <thead>
                    <tr>
                        <th>
                            <HeaderWithHelp help="Blatt der Cosmos-Liste, in dem die Zeile steht.">Marke</HeaderWithHelp>
                        </th>
                        <th>
                            <HeaderWithHelp help="Artikelcode von Cosmos (Spalte CODE).">Cosmos-Code</HeaderWithHelp>
                        </th>
                        <th>
                            <HeaderWithHelp help="Bezeichnung laut Cosmos-Liste.">Beschreibung</HeaderWithHelp>
                        </th>
                        <th className="text-end">
                            <HeaderWithHelp help="Menge laut Cosmos-Liste (Spalte STOCK) - brutto, enthält offene Bestellungen.">Dosen</HeaderWithHelp>
                        </th>
                        <th>
                            <HeaderWithHelp help="Warum die Zeile keine sichere Zuordnung hat.">Status</HeaderWithHelp>
                        </th>
                        <th>
                            <HeaderWithHelp help="Erläuterung zur Zeile, z. B. die Kandidaten bei einem Klärungsfall.">Hinweis</HeaderWithHelp>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {bestandsliste.meldungen.map((m, i) => {
                        const status = STATUS[m.status] || STATUS.nicht_zugeordnet;

                        return (
                            <tr key={`${m.cosmos_code}-${i}`}>
                                <td>{m.marke}</td>
                                <td>{m.cosmos_code}</td>
                                <td className="small">{m.beschreibung}</td>
                                <td className="text-end">{formatMenge(m.menge)}</td>
                                <td>
                                    <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} placement="top" overlay={<Tooltip id={`bestandsliste-status-${i}`}>{status.hilfe}</Tooltip>}>
                                        <span className={`badge ${status.klasse}`} style={{cursor: "help"}}>
                                            {status.label}
                                        </span>
                                    </OverlayTrigger>
                                </td>
                                <td className="small text-muted">{m.hinweis}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </>
    );
}
